import React from 'react'

function NotFound () {
  return (
    <div />
  )
}

export default NotFound
